// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['sr_RS']  = {
  "name": "sr_RS",
  "day": {
    "abbrev": [
      "нед",
      "пон",
      "уто",
      "сре",
      "чет",
      "пет",
      "суб"
    ],
    "full": [
      "недеља",
      "понедељак",
      "уторак",
      "среда",
      "четвртак",
      "петак",
      "субота"
    ]
  },
  "month": {
    "abbrev": [
      "јан",
      "феб",
      "мар",
      "апр",
      "мај",
      "јун",
      "јул",
      "авг",
      "сеп",
      "окт",
      "нов",
      "дец"
    ],
    "full": [
      "јануар",
      "фебруар",
      "март",
      "април",
      "мај",
      "јун",
      "јул",
      "август",
      "септембар",
      "октобар",
      "новембар",
      "децембар"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d.%m.%Y.",
  "time24": "%T",
  "dateTime": "%A, %d. %B %Y. %T %Z",
  "time12": "%T",
  "full": "%a, %e. %b %Y.  %H:%M:%S %Z\n"
}

